import React from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../ui/utils/Responsive';
import { ITokenizedCard } from '../../../domain/models';
import { useTranslationForType } from '../hooks/useTranslationForType';

interface ITokenizedCardTitleProps {
	card: ITokenizedCard;
}

export const TokenizedCardTitle = ({ card }: ITokenizedCardTitleProps) => {
	const title = useTranslationForType(card.creditCardType);
	const maskedCreditCardNumber = card.maskedCreditCardNumber.substr(-4);

	return (
		<StyledTokenizedCardTitle>{`${title} (${maskedCreditCardNumber})`}</StyledTokenizedCardTitle>
	);
};

const StyledTokenizedCardTitle = styled.h3`
	font-size: 20px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: 16px;
	}
`;
